import {
  downloadBookingPkpass,
  downloadBookingTickets,
} from '@/features/purchase/purchaseService';
import { TransText } from '@/i18n/trans/text';
import type { PurchaseFlowBookingStorageData } from '@/types/storage';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

const useDownloadTicket = (data: PurchaseFlowBookingStorageData | null) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [isPkPassDownloading, setIsPkPassDownloading] = useState(false);

  const handleTicketDownload = useCallback(async () => {
    if (!data?.bookingId) {
      return;
    }

    try {
      setIsDownloading(true);
      await downloadBookingTickets(
        data.bookingId,
        data.code,
        data.fulfillments
      );
    } finally {
      setIsDownloading(false);
    }
  }, [data?.bookingId, data?.code, data?.fulfillments]);

  const handlePkPassDownload = useCallback(async () => {
    if (!data?.bookingId) {
      return;
    }

    try {
      setIsPkPassDownloading(true);
      await downloadBookingPkpass(data.bookingId, data.code, data.fulfillments);
    } catch (error) {
      toast.error(<TransText i18nKey="errorDownloadingPkpass" />);
    } finally {
      setIsPkPassDownloading(false);
    }
  }, [data?.bookingId, data?.code, data?.fulfillments]);

  return {
    isDownloading,
    isPkPassDownloading,
    handleTicketDownload,
    handlePkPassDownload,
  };
};

export default useDownloadTicket;
